import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * One icon + title + description in a ProcessSteps row, plus the connecting
 * arrow(s) around it. Positioned relative to its own root (`.step-item`) so
 * the arrows — absolutely positioned — line up with this step's icon
 * regardless of how ProcessSteps lays the row out.
 *
 * @param {{icon: object, title: import("react").ReactNode, description: import("react").ReactNode}} step
 * @param {boolean} isFirst
 * @param {boolean} isLast
 */
export default function ProcessStepItem({ step, isFirst, isLast }) {
  return (
    <div className="step-item d-flex flex-row flex-lg-column gap-3 gap-lg-2 align-items-start align-items-lg-center justify-content-start justify-content-lg-center position-relative">
      {/* Decorative arrow before the first step */}
      {isFirst && <div className="arrow arrow-before" />}

      <div className="icon-wrapper mb-lg-3">
        <div className="icon rounded-circle d-flex align-items-center justify-content-center">
          <FontAwesomeIcon icon={step.icon} fixedWidth size="lg" />
        </div>
        {/* Connecting arrow to the next step */}
        {!isLast && <div className="arrow" />}
      </div>

      <div className="step-content text-start text-lg-center">
        <h3 className="step-title mb-2">{step.title}</h3>
        <p className="step-description mb-0">{step.description}</p>
      </div>

      {/* Decorative arrow after the last step */}
      {isLast && <div className="arrow arrow-after" />}
    </div>
  );
}
